import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { WalletService } from "../services/wallet.service";
import { ApiService } from "../services/api.service";

@Component({
    selector: "ngx-token-release",
    templateUrl: "./token-release.component.html",
    styleUrls: ["./token-release.component.scss"],
})
export class TokenReleaseComponent implements OnInit {
    public tokenReleaseForm: FormGroup;
    public whitelistForm: FormGroup;
    public whitelistStatus: boolean;
    public currentUserAddress: any;
    public activeStage: any
    constructor(
        private _fb: FormBuilder,
        private _walletService: WalletService,
        private _apiService: ApiService
    ) {}

    ngOnInit(): void {
        this.getActiveStage();
        this.getWhitelistStatus();
        this.tokenReleaseForm = this._fb.group({
            walletAddress: ["", Validators.required],
        });
        this.whitelistForm = this._fb.group({
            whitelistAddress: ["", Validators.required],
        });
        this.checkConnectionAddress();
    }
    getActiveStage() {
        this._apiService.getActiveStage(1).subscribe((res)=> {
            console.log(res);
            this.activeStage = res['uniqueID'];
        }) 
    }
    tokenRelease() {
        this._walletService.releaseTokensMetamask(
            this.tokenReleaseForm.controls["walletAddress"].value, this.activeStage
        );
    }

    checkConnectionAddress = async () => {
        if ((await this._walletService.getAddress()) === undefined) {
            this.currentUserAddress =
                await this._walletService.getCryptoComAddress();
        } else {
            this.currentUserAddress = await this._walletService.getAddress();
        }
    };

    whitelistAddress() {
        console.log(this.whitelistForm.controls["whitelistAddress"].value);

        let userData = {
            walletAddress:
                this.whitelistForm.controls["whitelistAddress"].value,
        };
        this._apiService.addUserToWHitelist(userData).subscribe();
    }

    // Get whitelist status and store it in this.whitelistStatus
    // getWhitelistStatus se poziva u ngOnInit

    getWhitelistStatus() {
        this._apiService.getCurrentWhitelistStatus(1).subscribe((res) => {
            this.whitelistStatus = res["isActive"];
        });
    }

    // kad korisnik klikne na button treba poslati !this.whitelistStatus (e.g. this._apiService.setWhitelistStatus(!this.whitelistStatus)) da se postavi suprotno od trenutnog statusa
    toggleWhitelistStatus() {
        this._apiService
            .changeCurrentWhitelistStatus(1, !this.whitelistStatus)
            .subscribe((res) => {
                this.getWhitelistStatus();
            });
    }
}
